import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import CarDeliveryDateCard from "./component";
import { updatePaymentSummaryStatus } from "../my-bookings/actions";

const mapStateToProps = ({
    checkout: {
        order: {
            financeProvider,
            splitPaymentOpted,
            orderId
        } = {}
    } = {},
    carDetails: {
        content,
        config
    } = {},
    myBookings: {
        paymentSummaryData
    } = {}
}) => ({
    content,
    config,
    financeProvider,
    paymentSummaryData,
    splitPaymentOpted,
    orderId
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    updatePaymentSummaryStatusConnect: updatePaymentSummaryStatus
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(CarDeliveryDateCard);
